import { defineStore } from 'pinia';
import { useStoreCompat } from "@/composables/useStoreCompat";
import { ref } from 'vue';
import { useRouterCompat } from '@/composables/useRouterCompat';

export const useValidationsStore = defineStore('validations', () => {

  const store = useStoreCompat();
  const {route, router} = useRouterCompat()

  //Es importante no cambiar el orden de los elementos del siguiente array, ya que muchas acciones dependen de sus respectivos índices
  let categorizedErrors = [
    {
      type: "affecteds",
      textName: "Afectados",
      passed: false,
      validationFunction: function () {
        try {
          let passed = false;
          store.state.sumario.denunciante.list.length > 1 ? passed = true : passed = false;
          this.passed = passed;
        } catch (e) {
          console.error("Error with 'affecteds':", e);
          this.passed = false;
        }
      }
    },
    {
      type: "deposition",
      textName: "Relato",
      passed: false,
      validationFunction: function () {
        try {
          let passed = true;
          let minLength = 600;
          if (store.state.sumario.actuationEditModeActive) {
            this.passed = true;
            return;
          }
          if (store.state.sumarioViews.actuacion === "contravencional-oficio" || store.state.sumarioViews.actuacion === "contravencional-denuncia") minLength = 400;
          if (store.state.sumario.deposition.length < minLength) passed = false;
          this.passed = passed;
        } catch (e) {
          console.error("Error with 'deposition':", e);
          this.passed = false;
        }
      }
    },
    {
      type: "interveningPersonnel",
      textName: "Personal interviniente",
      passed: false,
    },
    {
      type: "datesAndLocations",
      textName: "Fecha, hora y ubicación",
      passed: false,
      validationFunction: function () {
        try {
          let passed = false;
          if (store.state.sumario.preUbicacion !== "string" && Object.keys(store.state.sumario.preUbicacion).length > 0) {
            passed = true;
          } else {
            passed = false;
          }
          this.passed = passed;
        } catch (e) {
          console.error("Error with 'datesAndLocations':", e);
          this.passed = false;
        }
      }
    },
    {
      type: "legalData",
      textName: "Datos legales",
      passed: false,
      validationFunction: function () {
        try {
          /**
           * ActuacionUfi.Numero
           * Sitio.TipoSitioID
           * assistant.PersonalfiscalID
           * causaCaratula.Nombre
           * causaNumero
           * modusOperandi.TipomodusoperandiID
           * prosecutor.PersonalfiscalID
           */
          if(route.params.mode === 'edit') this.passed = true; 
          const {
            ActuacionUfi,
            Sitio,
            assistant,
            causaCaratula,
            causaNumero,
            modusOperandi,
            prosecutor
          } = store.state.sumario
          const camposValidos =
            ActuacionUfi?.Numero &&
            Sitio?.TipoSitioID &&
            assistant?.PersonalfiscalID &&
            causaCaratula?.Nombre &&
            causaNumero &&
            modusOperandi?.TipomodusoperandiID &&
            prosecutor?.PersonalfiscalID;
          if (camposValidos) {
            this.passed = true;
            return;
          }
          /**
           * Revisar Esta validación funciona rarito...
           */
        } catch (e) {
          console.error("Error with 'legalData':", e);
          this.passed = false;
        }
      },
      actuationShortcut: false
    },
  ]

  const getValidationData = async () => {
    try {
      categorizedErrors.map(categorizedError => {
        if (categorizedError.validationFunction !== undefined) categorizedError.validationFunction();
      });
      return categorizedErrors;
    } catch (e) {
      console.error("Error al obtener 'categorizedErrors':", e);
      return 0;
    }
  }

  return {
    getValidationData,
    categorizedErrors
  };
});
